import React, { Component } from 'react';
class Grid extends Component {
    render() {
        const { data, renderItem, keyExtractor } = this.props;
        return (React.createElement("div", { style: wrapper }, data.map((item, index) => (React.createElement("div", { key: keyExtractor(item, index) }, renderItem(item))))));
    }
}
export default Grid;
const wrapper = {
    display: 'grid',
    gridTemplateColumns: '200px 200px 200px',
    gridGap: '10px',
    backgroundColor: '#fff',
    color: '#444',
    margin: '40px'
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Grid.tsx
// module id = 495
// module chunks = 0